
<template>
    <div class="confirm-task-container" :class="{'read-only': readOnly, 'accepted': item.accepted && readOnly}" v-click-outside="editingMode">
        <transition name="expand">
            <div class="expandable" v-show="isEditing ||  item.content == ''">
                <div class="task-label" v-if="!readOnly" >
                    <span>
                        {{toLocal('task.doc_confirmation')}}
                    </span>
                    <div class="options-container">
                        <span class="label">
                            {{toLocal('task.show_without')}}
                        </span>
                        <div class="btn-container">
                            <div 
                                class="option-button" 
                                :class="{active: item.showContent}"
                                @click="$set(item, 'showContent', true)"
                            >
                            {{toLocal('training_edit.answer_yes')}}
                            </div>
                            <div 
                                class="option-button" 
                                :class="{active: !item.showContent}"
                                @click="$set(item, 'showContent', false)"
                            >
                           {{toLocal('training_edit.answer_no')}}
                            </div>    
                        </div>    
                    </div>                    
                </div>
                <div class="url-container">
                    <div class="url-input"   v-if="!readOnly">
                        <input 
                            type="text"
                            :placeholder="toLocal('task.acknowledgement')"
                            v-model="item.content"
                            @mouseover="toggleDrag(true)"
                            @mouseleave="toggleDrag(false)"
                        >
                    </div>
                    <div class="button-label"   v-if="item.content && !readOnly">
                        {{toLocal('task.button_preview')}}
                    </div>
                </div>
            </div>
        </transition>
        <div 
            class="button" 
            v-if="item.content"
            @mouseover="toggleDrag(true)"
            @mouseleave="toggleDrag(false)"
            @click="confirm"
        >
            <p>{{item.content}}</p>
            <div v-if="readOnly ? item.accepted : true">
                <svg xmlns="http://www.w3.org/2000/svg" width="49.467" height="46.222" viewBox="0 0 49.467 46.222">
                    <path id="Path_5921" data-name="Path 5921" d="M-379.365-14979.586l14.845,20.379,24.885-37.875" transform="translate(384.255 15001.929)" fill="none" stroke="#28345c" stroke-linecap="round" stroke-linejoin="round" stroke-width="7"/>
                </svg>
            </div>
        </div>
        <div 
        :class="['media--editing', 'url--editing']"
        v-if="!readOnly"
        >
          <div class="media--action" v-show="!isEditing && item.content != ''">
            <svg @click="isEditing=true" class="fill" xmlns="http://www.w3.org/2000/svg" width="37.214" height="37.214" viewBox="0 0 37.214 37.214">
              <g id="Nustatymai" transform="translate(12 -0.001)">
                <g id="Group_50" data-name="Group 50" transform="translate(-12 0.001)">
                  <path id="Path_69" data-name="Path 69" d="M35.309,14.7,32.7,14.259a14.749,14.749,0,0,0-1.049-2.534l1.539-2.153a2.292,2.292,0,0,0-.249-2.962L30.622,4.292A2.282,2.282,0,0,0,29,3.616a2.259,2.259,0,0,0-1.329.428L25.506,5.583A14.6,14.6,0,0,0,22.879,4.5l-.435-2.581A2.3,2.3,0,0,0,20.174,0H16.9a2.3,2.3,0,0,0-2.27,1.92L14.18,4.564a14.386,14.386,0,0,0-2.527,1.065L9.515,4.09a2.3,2.3,0,0,0-2.962.249L4.229,6.656A2.3,2.3,0,0,0,3.98,9.617L5.535,11.8A14.406,14.406,0,0,0,4.5,14.344l-2.581.435A2.3,2.3,0,0,0,0,17.049v3.273a2.3,2.3,0,0,0,1.92,2.27l2.643.451A14.386,14.386,0,0,0,5.628,25.57L4.1,27.7a2.292,2.292,0,0,0,.249,2.962l2.317,2.317a2.282,2.282,0,0,0,1.625.676,2.259,2.259,0,0,0,1.329-.428L11.8,31.672a14.707,14.707,0,0,0,2.457,1.011l.435,2.612a2.3,2.3,0,0,0,2.27,1.92h3.281a2.3,2.3,0,0,0,2.27-1.92l.443-2.612a14.749,14.749,0,0,0,2.534-1.049l2.153,1.539a2.282,2.282,0,0,0,1.337.428h0a2.282,2.282,0,0,0,1.625-.676l2.317-2.317a2.3,2.3,0,0,0,.249-2.962l-1.539-2.161a14.643,14.643,0,0,0,1.049-2.534l2.612-.435a2.3,2.3,0,0,0,1.92-2.27V16.972A2.269,2.269,0,0,0,35.309,14.7Zm-.179,5.543a.2.2,0,0,1-.171.2l-3.265.544a1.044,1.044,0,0,0-.84.77A12.445,12.445,0,0,1,29.5,25.018a1.051,1.051,0,0,0,.047,1.143l1.92,2.705a.212.212,0,0,1-.023.264l-2.317,2.317a.2.2,0,0,1-.148.062.191.191,0,0,1-.117-.039l-2.7-1.92a1.05,1.05,0,0,0-1.143-.047,12.445,12.445,0,0,1-3.257,1.353,1.032,1.032,0,0,0-.77.84l-.552,3.265a.2.2,0,0,1-.2.171H16.971a.2.2,0,0,1-.2-.171L16.224,31.7a1.044,1.044,0,0,0-.77-.84,12.922,12.922,0,0,1-3.187-1.306,1.076,1.076,0,0,0-.529-.14,1.024,1.024,0,0,0-.606.194L8.411,31.54a.231.231,0,0,1-.117.039.208.208,0,0,1-.148-.062L5.83,29.2a.211.211,0,0,1-.023-.264L7.72,26.254A1.064,1.064,0,0,0,7.766,25.1,12.328,12.328,0,0,1,6.4,21.854a1.065,1.065,0,0,0-.84-.77l-3.288-.56a.2.2,0,0,1-.171-.2V17.049a.2.2,0,0,1,.171-.2L5.512,16.3a1.051,1.051,0,0,0,.847-.777,12.432,12.432,0,0,1,1.329-3.265,1.038,1.038,0,0,0-.054-1.135L5.7,8.4a.212.212,0,0,1,.023-.264L8.038,5.824a.2.2,0,0,1,.148-.062A.191.191,0,0,1,8.3,5.8l2.682,1.912a1.064,1.064,0,0,0,1.151.047,12.328,12.328,0,0,1,3.25-1.368,1.065,1.065,0,0,0,.77-.84l.56-3.288a.2.2,0,0,1,.2-.171h3.273a.2.2,0,0,1,.2.171L20.935,5.5a1.051,1.051,0,0,0,.777.847,12.618,12.618,0,0,1,3.335,1.368,1.051,1.051,0,0,0,1.143-.047l2.682-1.928a.231.231,0,0,1,.117-.039.208.208,0,0,1,.148.062l2.317,2.317a.211.211,0,0,1,.023.264l-1.92,2.7a1.05,1.05,0,0,0-.047,1.143,12.445,12.445,0,0,1,1.353,3.257,1.032,1.032,0,0,0,.84.77l3.265.552a.2.2,0,0,1,.171.2v3.273Z" transform="translate(0 -0.001)" fill="#707070"/>
                  <path id="Path_70" data-name="Path 70" d="M144.131,136a8.031,8.031,0,1,0,8.031,8.031A8.036,8.036,0,0,0,144.131,136Zm0,13.962a5.932,5.932,0,1,1,5.932-5.932A5.935,5.935,0,0,1,144.131,149.963Z" transform="translate(-125.52 -125.428)" fill="#707070"/>
                </g>
              </g>
            </svg>
          </div>
          <div class="media--action">
              <img 
              src="@/assets/images/icons/training-item-remove.svg"
              @click="removeItem"
              >
          </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
 data(){
    return{
        isEditing: false,
    }
 },
 props:{
    readOnly:{
        type: Boolean,
        default: true
    },
    item:{
        type: Object,
    },
    training_key:{
        type: String,
    },
    topic:{
        type: Object,
    },
 },
 mounted(){
    if(this.item != undefined && this.item.showContent == undefined){
        this.$set(this.item, 'showContent', true);
    }
    if(this.item && this.item.content == ''){
        this.isEditing=true;
    }
 },
 methods:{
    toggleDrag(toggle){
        this.$emit('toggleDrag', toggle);
    },
    confirm(){
        if(!this.readOnly || this.item.accepted) return;
        axios.post( 
        `${this.$store.state.api_link}/training/task/confirm`,
        {
            training_id: this.$store.state.currentTraining,
            item_id: this.item.id,
            topic_id: this.topic.id,
            is_rented: this.$store.state.currentTrainingRented,
            key: this.training_key,
        },
        this.$store.getters.axiosConfig()
        ).then((response) => {
            this.$set(this.item, 'accepted', true);
            this.$set(this.item, 'can_progress', true);
        }).catch((error) => {
        console.log(error)
        });
    },
    removeItem(){
        if(this.readOnly) return;
       this.$emit('removeItem')
    },
     editingMode(e){

        if(!this.readOnly){
            this.isEditing = false;
        }
       
    },
 }
}
</script>

<style lang="scss" scoped>

@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_trainingEdit.scss";
.confirm-task-container{
    display: flex;
    flex-direction: column;
    padding: 20px;
    &.read-only{
        // padding: 0;
    }
    .button{
        div{
            svg{

                display: none;
            }
        }
    }

    &.accepted{
        .button{
            font-weight: 700;
             //border: 2px solid var(--primary-color);
             border-radius: 3rem;
             flex-flow: row-reverse;
            //  background: var(--third-color);
             div{
                right: initial;
                left: 29px;
                background: white;
                border-radius: 50%;
                padding: 10px;
                svg{
                    display: block;
                    height: 35px;
                    width: 35px;
                }
             }
             &:active{
                border: none;
            }
        }
    
    }
    &:hover{
        .media--editing.url--editing{
        opacity: 1;
        }
    }



}
.task-label{
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid var(--primary-color);
    font-weight: 700;
    color: var(--primary-color);

}
 .url-container{
    display: flex;
    flex-direction: column;
    color: var(--primary-color);
    .url-label{
      display: flex;
      font-size: 12px;
      margin: 5px 0;
    }
    .url-input{
        padding: 10px 0;
      input{
        display: flex;
        width: 100%;
        background: #EFEFEF;
        color: var(--primary-color);
        padding: 10px;
        border: none;
        border-radius: 10px;
        font-size: 14px;
      }
    }
  }
  .button{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    font-weight: 500;
    font-size: 32px;
    background: var(--secondary-color);
    border-radius: 10px;
    word-wrap: anywhere;
    cursor: pointer;
    color:var(--primary-color);
    text-align: center;
    transition: 0.3s border-radius;
    min-height: 70px;
    p{
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0;
        text-align: center;
        justify-content: center;
        color:var(--primary-color);
        text-align: center;
        padding:0 70px;
        word-wrap: anywhere;
    }
    div{
        position: absolute;
        display: flex;
        align-items: center;
        // padding-left: 1rem;
        right: 40px;
        svg{
            path{
                stroke: var(--primary-color);
            }
        }
    }
    &:hover{
        font-weight: 700;
        border-radius: 3rem;
    }
    &:active{
        border: 2px solid var(--primary-color);

    }
  }
  .button-label{
    padding: 5px 10px 15px 10px;
    color:var(--primary-color);
    font-size: 16px;
  }
.content--item .media--editing.side--editing{
    bottom: -26px;
  }
     .media--editing.url--editing{
    display: flex;
    opacity: 0;
    position: absolute;
    justify-content: center;
    left: 0;
    right: 0;
    height: 25px;
    bottom: 7px;

    margin: 0 auto;
    width: fit-content;
    transition: 0.3s all;
    gap: 5px;
    z-index: 3;
    .media--action{
      width: auto;
      min-width: 50px;
      min-height: 50px;
      max-width: 50px;
      max-height: 50px;
      align-items: center;
      display: flex;
      justify-content: center;
      background: white;
      border-radius: 50%;
      padding: 8px;
      -webkit-box-shadow: 0px 0px 5px -2px #000000;
      box-shadow: 0px 0px 5px -2px #000000;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
        img {
            height: 30px;
            width: auto;
            // margin: 30px 15px;
            margin: 10px;

        }
    }
   }
   .options-container{
        display: flex;
        align-items: center;
        .label{
            font-weight: 500;
            font-size: 16px;
        }
        .btn-container{
            display: flex;
            align-items: center;
            .option-button{
                display: flex;
                border: 1px solid var(--primary-color);
                border-radius: 10px;
                padding: 2px 10px;
                font-weight: 500;
                font-size: 16px;
                width: 50px;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                &.active{
                    background: var(--third-color);
                }
            }
            .option-button:first-child{
                margin: 0 0.75rem;
            }
        }
   }
</style>